import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import styles from './ErrorBoundary.scss';

class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    });

    console.error('ErrorBoundary error ===== ', error);
    console.error('ErrorBoundary info ===== ', info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.boundary}>
          <div className={styles.heading}>Aj då, något gick fel : (</div>
          <div className={styles.subHeader}>Vänligen ladda om sidan</div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
};

export default withRouter(ErrorBoundary);
